import { render, staticRenderFns } from "./RankingPage.vue?vue&type=template&id=30028252&scoped=true"
import script from "./RankingPage.vue?vue&type=script&lang=js"
export * from "./RankingPage.vue?vue&type=script&lang=js"
import style0 from "./RankingPage.vue?vue&type=style&index=0&id=30028252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30028252",
  null
  
)

export default component.exports